import React, { Component, ReactElement } from "react";
import Strings from "@my-dld/assets/strings";
import { DropzoneInputProps } from "react-dropzone";

interface Props {
	groupClassName?: string;
	containerClassName?: string;
	inputClassName?: string;
	labelClassName?: string;
	iconClassName?: string;
	errorClassName?: string;
	required?: boolean;
	label?: string;
	error?: string;
	dropZoneInputProps: DropzoneInputProps;
	isDocsAdded: boolean;
	disabled?: boolean;
}

interface State {
	isFocus: boolean;
}

class DocumentInputField extends Component<Props, State> {
	static defaultProps: Partial<Props> = {
		groupClassName: "form-group",
		containerClassName: "custom-file",
		inputClassName: "custom-file-input",
		labelClassName: "custom-file-label",
		iconClassName: "fas fa-upload",
		errorClassName: "invalid-feedback invalid-feedback-x",
	};

	constructor( props: Props ) {
		super( props );
		this.state = {
			isFocus: false,
		};
	}

	private static getDocInputStyle( isFocus: boolean, isDocsAdded: boolean, isRequired?: boolean, error?: string | ReactElement ) {
		if ( isFocus ) {
			return " focus-validation";
		} else if ( isRequired && ( !isDocsAdded || error ) ) {
			return " empty-validation";
		} else if ( isDocsAdded ) {
			return " valid-validation";
		} else if ( error ) {
			return " empty-validation";
		}
		return "";
	}

	render() {
		const {
			groupClassName, containerClassName, inputClassName, labelClassName, iconClassName, errorClassName,
			required, label, error, dropZoneInputProps, isDocsAdded, disabled
		} = this.props;
		let inputStyle = DocumentInputField.getDocInputStyle( this.state.isFocus, isDocsAdded, required, error );
		return <div className={ groupClassName }>
			{ label && <label>{ label }</label> }{ required && <span className="asterisk">*</span> }
			<div className={ containerClassName }>
				<input
					className={ inputClassName + inputStyle } { ...dropZoneInputProps }
					onFocus={ this.onFocus } onBlur={ this.onBlur } disabled={ disabled }/>
				<label className={ labelClassName }>{ Strings.choose_files }</label>
				<i className={ iconClassName }/>
			</div>
			{ error && <div className={ errorClassName }>{ error }</div> }
		</div>;
	}

	private onFocus = () => {
		this.setState( { isFocus: true } );
	};

	private onBlur = () => {
		this.setState( { isFocus: false } );
	};
}

export default DocumentInputField;
